export const environment = {

        production: false,
        apiEndpoint:"https://roar-stage-functions-djgzb5eze3dmf7dk.eastus2-01.azurewebsites.net/",
        scopes:["api://d40cee0a-08de-441e-a504-686edcf1974b/ROAR_API_ACCESS"],
        redirectUri:'https://roar-customerrefundapplication-stage.constellation.com/',
        postLogoutRedirectUri:'https://cdn-roar-stage.azureedge.net/#/log-out',
        clientid:'98792634-ffa4-4d5d-978f-185d6611b291',
        authority: 'https://login.microsoftonline.com/d8fb9c07-c19e-4e8c-a1cb-717cd3cf8ffe',
        instrumentationKey: '68d7dcdd-d579-4570-a79d-2dbcee9dd15e',
        AppInsightApiId: '35d8cb73-420f-4478-9f9a-c0b5f7f044fb',
        AppInsightApiKey: 'vctu7ih14btksmx4v1jeh6knvf4u28oeovr2u17h',
        defaultenv:"Stage",
        Settings: {
            AllowEditResponse: true,
            EnvironmentBoxText: 'LOCAL',
            EnvironmentBoxBG: 'environment-box-bg-local'
        },
        welcomeAreaColor: '#db7714ff',
        welcomeAreaGradient: 'linear-gradient(rgba(155, 105, 56, 1), rgba(192, 106, 56, 0.36)), url(/assets/img/qbert.png)',
        
     }